<template>
  <div>
    <v-form @submit.prevent="submit">
      <v-text-field label="회사명" v-model="form.name" outlined ref="shouldFocused"></v-text-field>
      <v-btn type="submit" color="primary">{{ submitText }}</v-btn>
    </v-form>
  </div>
</template>

<script>
import { addCompany, getCompany, editCompany } from '@/api'

export default {
  props: {
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      id: null,
      form: {
        name: ''
      }
    }
  },
  mounted () {
    this.$refs.shouldFocused.focus()
  },
  computed: {
    submitText () {
      return this.edit ? '편집' : '등록'
    }
  },
  async beforeRouteEnter (to, from, next) {
    const id = to.params.id

    if (!id) return next()

    try {
      const company = await getCompany(id)

      next(vm => {
        vm.id = id
        vm.form.name = company.name
      })
    } catch (err) {
      console.log(err.message)
      next()
    }
  },
  methods: {
    async submit () {
      if (!confirm('이대로 적용 하시겠습니까?')) return
      this.edit ? this.putCompany() : this.postCompany()
    },
    async postCompany () {
      try {
        await addCompany(this.form)
        this.$router.go(-1)
      } catch (err) {
        alert(err.message)
      }
    },
    async putCompany () {
      try {
        await editCompany(this.id, this.form)
        this.$router.go(-1)
      } catch (err) {
        alert(err.message)
      }
    }
  }
}
</script>
